// Brand palette derived from "The 99" logo:
//   - Deep navy outer ring / "The" text:  #0A1A33 → #122B52
//   - Gradient "99":                       #1A3568 → #2563EB
//   - Bright electric circuit accents:     #3B82F6 → #60A5FA
//   - Pale highlight:                      #BFDBFE
// Theme keys are kept stable so the entire app picks up the new look.
// Light mode is tuned for outdoor/daylight legibility; dark mode for low light.
const THEMES = {
  dark: {
    deepWater: "#0A1A33",   // app background (deep navy)
    midnight:  "#0F2547",   // nav / elevated surfaces
    teal:      "#1E4D9C",   // primary deep blue (was teal)
    seafoam:   "#2563EB",   // brand blue (was seafoam)
    accent:    "#3B82F6",   // bright electric blue accent
    gold:      "#60A5FA",   // light cyan-blue highlight (replaces warm gold)
    sand:      "#BFDBFE",   // pale blue tint for subtle text
    white:     "#FFFFFF",   // primary text on dark
    muted:     "#8AA4C4",   // secondary text on dark
    dark:      "#06101F",   // deepest shadow
    cardBg:    "#13284A",   // card surface
    warning:   "#E07B39",   // functional orange (kept)
    red:       "#E03030",
    videoRed:  "#CC2222",
    border:    "#1E3A6B",
    settingsBg: "rgba(10,20,40,0.96)",
    menuShadow: "0 10px 30px rgba(0,0,0,0.65)",
    appBackdrop: "#04080F",
    frameShadow: "0 30px 80px rgba(0,0,0,0.8), 0 0 0 1px #1E3A6B",
  },
  light: {
    deepWater: "#F4F8FD",   // app background (near white, slight blue tint)
    midnight:  "#E3ECF8",   // nav / elevated surfaces
    teal:      "#0F2547",   // deep navy (primary on light)
    seafoam:   "#1E4D9C",   // brand mid blue
    accent:    "#2563EB",   // bright brand blue for highlights/CTAs
    gold:      "#1746A2",   // strong blue used where gold appeared (high contrast on light)
    sand:      "#3B6EC2",   // mid blue for subtle accents
    white:     "#0A1A33",   // primary text on light (deep navy)
    muted:     "#4F6A8A",   // secondary text on light
    dark:      "#EAF1FA",
    cardBg:    "#FFFFFF",   // card surface (pure white)
    warning:   "#B65D24",
    red:       "#B73333",
    videoRed:  "#A82323",
    border:    "#C2D3E6",
    settingsBg: "rgba(244,248,253,0.97)",
    menuShadow: "0 10px 30px rgba(15,37,71,0.18)",
    appBackdrop: "#E8F0FA",
    frameShadow: "0 20px 50px rgba(15,37,71,0.22), 0 0 0 1px #C2D3E6",
  },
};

let currentTheme = "dark";

export const C = { ...THEMES.dark };

export const setTheme = (themeMode) => {
  currentTheme = themeMode === "light" ? "light" : "dark";
  Object.assign(C, THEMES[currentTheme]);
  return currentTheme;
};

export const getTheme = () => currentTheme;

export const fmt = t => `${String(Math.floor(t/60)).padStart(2,"0")}:${String(t%60).padStart(2,"0")}`;
